const bottomOffset = 1600;

$(document).ready( function() {

    $('.realisation-filter-btn').on("click", function(){
      $('.realisation-filter-btn').removeClass('active');
      $(this).addClass('active');

      let slug_term = $(this).attr('attr-slug_term');
      window.history.replaceState(null, null, "?terms="+slug_term);
      filter(slug_term);
    });

    function filter(terms){

        $('#load-more').attr('attr-paged', '1');

        $.ajax({
          type: 'POST',
          url: '/wp-admin/admin-ajax.php',
          dataType: 'json',
          data: {
            action: 'realisations_load_more',
            terms,
            paged : $('#load-more').attr('attr-paged')
          },
          success: function (res) {
            $('#itemRealisation-list').html('');
            $('#itemRealisation-list').append(res.html);

            $('#load-more').attr('attr-slug_term', terms);
            $('#load-more').attr('attr-loaded', 'true');

            $('html, body').stop().animate({
              scrollTop: $('#accordion-start').offset().top
            }, 0);
          }
        });

    }

    //Smoothscroll
    $("#nav-equipement a").on('click', function(event) {

        if (this.hash !== "") {
          event.preventDefault();

          // Store hash
          var hash = this.hash;

          $('html, body').stop().animate({
            scrollTop: $(hash).offset().top - 150
          }, 800, function(){
            window.history.replaceState(null, null, hash);
          });
        }
      });

      // Gestion menu accordéon
      if($('body').find('.dropdownlink').length){
        var Accordion = function(el, multiple) {
          this.el = el || {};
          // more then one submenu open?
          this.multiple = multiple || false;

          var dropdownlink = this.el.find('.dropdownlink');
          dropdownlink.on('click',
                          { el: this.el, multiple: this.multiple },
                          this.dropdown);
        };

        Accordion.prototype.dropdown = function(e) {
          var $el = e.data.el,
              $this = $(this),
              //this is the ul.submenuItems
              $next = $this.next();

          $next.slideToggle('medium', function() {
            if ($(this).is(':visible'))
              $(this).css('display','flex');
          });
          $this.parent().toggleClass('open');

          if(!e.data.multiple) {
            //show only one menu at the same time
            $el.find('.submenuItems').not($next).slideUp().parent().removeClass('open');
          }
        };

        var accordion = new Accordion($('.accordion-menu'), false);
      }


      if (window.matchMedia("(max-width: 768px)").matches) {
        // $('.submenuItems').css('display', 'none');
        if( $('.accordion-menu').hasClass('open') ){
          $('.dropdownlink').click();
        }
      }

});

$(document).on("scroll", function() {

  if( $(document).scrollTop() > ( $(document).height() - bottomOffset ) && $('#load-more').attr('attr-loaded') == 'true' ){
    $('#load-more').attr('attr-loaded', 'false');
    loadMore( parseInt($('#load-more').attr('attr-paged')) + 1 , $('#load-more').attr('attr-slug_term'));
    $('#load-more').attr('attr-paged', parseInt($('#load-more').attr('attr-paged')) + 1 );
  }

  setTimeout(() => {

  // On attend que le DOM soit totalement chargé
    if ($(".accordion-menu").length) {

      const stopSticky = $("#accordion-start").offset().top - 21;

      var $sticky = $("#accordion-menu");
      var stickyH = $sticky.outerHeight() + 10 + 'px';

      var scrollTop = $(window).scrollTop();

      if (scrollTop >= stopSticky) {
          $sticky.addClass('sticky');
          // On ajoute le montant à l'élément suivant
          $sticky.next().css('margin-top', stickyH);
      } else {
          $sticky.removeClass('sticky');
          $sticky.next().css('margin-top', '0px');
      }
    }
  }, 0);
});

function loadMore(paged,terms) {

  $('.lds-dual-ring').addClass('active');

  $.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php',
    dataType: 'json',
    data: {
      action: 'realisations_load_more',
      paged,
      terms,
    },
    success: function (res) {
      $('.lds-dual-ring').removeClass('active');
      $('#itemRealisation-list').append(res.html);

      if(paged >= res.max) {
        $('#load-more').attr('attr-loaded', 'false');
      }else{
        $('#load-more').attr('attr-loaded', 'true');
      }
    }
  });
}
